import { appConfig } from '../config';

interface HeaderProps {
  username: string;
}

export function Header({ username }: HeaderProps): JSX.Element {
  const signOut = (): void => {
    window.location.assign('/auth/logout');
  };

  return (
    <header className="flex flex-wrap items-center justify-between gap-3 border-b border-slate-700 bg-kore-card px-6 py-4">
      <div className="flex items-center gap-3">
        <h1 className="text-lg font-semibold text-white">KoreID Bank Settlement Control</h1>
        <span className="rounded-full border border-amber-500 bg-amber-900/40 px-2 py-0.5 text-xs font-medium text-amber-300">
          {appConfig.environment}
        </span>
      </div>
      <div className="flex items-center gap-4">
        <span className="text-sm text-slate-300" aria-label="Authenticated user">
          Logged in as <span className="font-medium text-white">{username}</span>
        </span>
        <button
          type="button"
          onClick={signOut}
          className="rounded border border-slate-500 bg-slate-800 px-3 py-1.5 text-sm hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-kore-accent"
        >
          Sign Out
        </button>
      </div>
    </header>
  );
}
